import React, { useState, useRef, useEffect } from 'react';
import { Send, Phone, MapPin, BookOpen, User, CheckCircle, Printer, Smartphone, Upload, X, Settings } from 'lucide-react';
import FullscreenSpinner from "./Spinner"; // ruta correcta según tu archivo


export default function FormularioContacto() {
  // ESTADO PARA LOGOS (Imágenes reales)
  const [logoPTV, setLogoPTV] = useState('/imagenes/logoPTV.svg');
  const [logoAFA, setLogoAFA] = useState('/imagenes/logo_AFA.jpg');
  const [loading, setLoading] = useState(false);
  const estadoInicialErrores = {nombre_completo: [],curso_estudiante: [],telefono_contacto: [],direccion: [],servicios_interes: []};
  const estadoInicialFormData = {nombre_completo: '',curso_estudiante: '',telefono_contacto: '',direccion: '',servicios_interes: []};

  const [mensajesError, setMensajesError] = useState(estadoInicialErrores);
  const [formData, setFormData] = useState(estadoInicialFormData);

  // Estado para el formulario
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleServiceChange = (check, service) => {
    setFormData(prev => ({
      ...prev,
      servicios_interes: check
        ? [...prev.servicios_interes, service]
        : prev.servicios_interes.filter(s => s !== service),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensajesError(estadoInicialErrores);

    try {
      const response = await fetch("https://cv2.ptvtelecom.net/api/v1/contactos/afa", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });      
        const data = await response.json();        
        const nuevoFormData = { ...estadoInicialErrores }; 
        for (let clave in data.mensaje) {
          if (data.mensaje.hasOwnProperty(clave)) {
            nuevoFormData[clave] = data.mensaje[clave];
          }
        }
        
      if (!data.estado) {   
        setMensajesError(nuevoFormData);
      }else{
        setFormSubmitted(true);
        setFormData(estadoInicialFormData);
      }
      
    } catch (err) {} finally {
      setLoading(false);
    }
  };

  

  return (
    
    <div className="min-h-screen bg-gray-100 font-sans" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700;900&display=swap');`}        
      </style>

      <div className="max-w-full mx-auto p-4 md:p-8">
        {/* --- FORMULARIO --- */}
        {<div className="bg-white rounded-2xl shadow-2xl overflow-hidden max-w-4xl mx-auto border border-gray-100">
            <div className="bg-black p-8 text-white text-center relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#e50695] opacity-20 rounded-full blur-3xl -mr-10 -mt-10"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-[#00b1aa] opacity-20 rounded-full blur-3xl -ml-10 -mb-10"></div>

              <div className="relative z-10 flex flex-col items-center">
                {/* LOGO DINÁMICO HEADER FORMULARIO (SIN FONDO BLANCO) */}
                <div className="mb-6">
                  {logoPTV ? (
                    /* Aplicamos brillo/inversión para asegurar que se vea blanco sobre negro */
                    <img src={logoPTV} alt="PTV Telecom" className="h-12 object-contain filter brightness-0 invert" />
                  ) : (
                    <h1 className="text-4xl font-black text-white tracking-tighter leading-none">
                      PTV<span className="text-[#00b1aa] font-light">TELECOM</span>
                    </h1>
                  )}
                </div>

                <h2 className="text-xl font-bold mb-1">Campaña Solidaria</h2>
                <div className="flex items-center gap-2 justify-center text-[#00b1aa] font-medium text-sm mt-2">
                   <span>En colaboración con:</span>
                   {logoAFA ? (
                     <img src={logoAFA} alt="AFA" className="h-10 object-contain rounded-sm bg-white/10 p-1" />
                   ) : (
                     <span className="bg-white/10 px-2 py-1 rounded">AFA AL-ÁNDALUS</span>
                   )}
                </div>
              </div>
            </div>

            <div className="p-8">
              {!formSubmitted ? (
                <form onSubmit={handleSubmit} className="space-y-5">                  
                  <p className="text-gray-600 text-sm mb-6 text-center leading-relaxed">
                    Déjanos tus datos para recibir la mejor oferta y apoyar a tu asociación.
                  </p>

                  <div className="group">
                    <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 group-focus-within:text-[#e50695] transition-colors">Nombre y Apellidos</label>
                    <div className="relative">
                      <User className="absolute left-3 top-3 h-5 w-5 text-gray-300 group-focus-within:text-[#e50695] transition-colors" />
                      <input 
                        name="nombre_completo"
                        type="text" 
                        className="pl-10 w-full p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#e50695] focus:border-transparent outline-none transition-all"
                        placeholder="Ej. Juan Pérez"
                        onChange={handleInputChange}
                      />

                      {mensajesError.nombre_completo.length > 0 && (
                        <div style={{ color: "red" }}>
                          {mensajesError.nombre_completo.map((error, index) => (
                            <div key={index}>{error}</div>
                          ))}
                        </div>
                      )}

                  
                    </div>
                  </div>
                  <div class="md:grid md:grid-cols-2 gap-x-5">
                    <div className="group">
                      <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 group-focus-within:text-[#00b1aa] transition-colors">Curso del alumno/a</label>
                      <div className="relative">
                        <BookOpen className="absolute left-3 top-3 h-5 w-5 text-gray-300 group-focus-within:text-[#00b1aa] transition-colors" />
                        <input 
                          name="curso_estudiante"
                          type="text" 
                          className="pl-10 w-full p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#00b1aa] focus:border-transparent outline-none transition-all"
                          placeholder="Ej. 3º Primaria"
                          onChange={handleInputChange}
                        />

                        {mensajesError.curso_estudiante.length > 0 && (
                          <div style={{ color: "red" }}>
                            {mensajesError.curso_estudiante.map((error, index) => (
                              <div key={index}>{error}</div>
                            ))}
                          </div>
                        )}

                      </div>
                    </div>

                    <div className="group pt-5 md:pt-0">
                      <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 group-focus-within:text-[#e50695] transition-colors">Teléfono de Contacto</label>
                      <div className="relative">
                        <Phone className="absolute left-3 top-3 h-5 w-5 text-gray-300 group-focus-within:text-[#e50695] transition-colors" />
                        <input                           
                          name="telefono_contacto"
                          type="tel" 
                          className="pl-10 w-full p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#e50695] focus:border-transparent outline-none transition-all"
                          placeholder="600 000 000"
                          onChange={handleInputChange}
                        />
                        
                        {mensajesError.telefono_contacto.length > 0 && (
                          <div style={{ color: "red" }}>
                            {mensajesError.telefono_contacto.map((error, index) => (
                              <div key={index}>{error}</div>
                            ))}
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="group">
                    <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-1 group-focus-within:text-[#00b1aa] transition-colors">Dirección (Cobertura)</label>
                    <div className="relative">
                      <MapPin className="absolute left-3 top-3 h-5 w-5 text-gray-300 group-focus-within:text-[#00b1aa] transition-colors" />
                      <input 
                        name="direccion"
                        type="text" 
                        className="pl-10 w-full p-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#00b1aa] focus:border-transparent outline-none transition-all"
                        placeholder="Calle, número..."
                        onChange={handleInputChange}
                      />

                       {mensajesError.direccion.length > 0 && (
                          <div style={{ color: "red" }}>
                            {mensajesError.direccion.map((error, index) => (
                              <div key={index}>{error}</div>
                            ))}
                          </div>
                        )}

                    </div>
                    
                  </div>

                  <div>
                    <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Servicios de interés</label>
                    <div className="grid grid-cols-2 gap-3">
                      {['Fibra Óptica', 'Móvil', 'Televisión', 'Fijo'].map((service) => (
                        <label key={service} className="flex items-center space-x-3 p-3 border border-gray-100 bg-gray-50 rounded-lg hover:border-[#00b1aa] hover:bg-[#e0f7f6] cursor-pointer transition-all">
                          <input 
                            type="checkbox" 
                            className="h-4 w-4 text-[#00b1aa] focus:ring-[#00b1aa] border-gray-300 rounded accent-[#00b1aa]"
                            onChange={(evento) => handleServiceChange(evento.target.checked, service)}
                          />
                          
                          <span className="text-gray-700 font-medium text-sm">{service}</span>
                        </label>
                      ))}
                       {mensajesError.servicios_interes.length > 0 && (
                          <div style={{ color: "red" }}>
                            {mensajesError.servicios_interes.map((error, index) => (
                              <div key={index}>{error}</div>
                            ))}
                          </div>
                        )}
                    </div>
                  </div>                                  
                  
                  {/* Spinner */}
                  {loading && <FullscreenSpinner />}

                  <button type="submit" className="m-auto mt-12 w-full md:w-3xs bg-[#e50695] text-white font-bold py-4 rounded-lg hover:bg-[#c40580] transition shadow-lg shadow-pink-500/20 flex justify-center items-center gap-2 uppercase tracking-wide text-sm">
                    <Send className="h-4 w-4" />
                    Solicitar Información
                  </button>

                  <p className="text-[10px] text-gray-400 text-center mt-3">
                    Tus datos serán tratados confidencialmente por PTV Telecom.
                  </p>


                </form>
              ) : (
                <div className="text-center py-16">
                  <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-[#e0f7f6] mb-6 animate-bounce">
                    <CheckCircle className="h-10 w-10 text-[#00b1aa]" />
                  </div>
                  <h3 className="text-2xl font-black text-gray-900 mb-2">¡Gracias!</h3>
                  <p className="text-gray-600 mb-8">
                    Tus datos se han enviado a PTV Telecom. <br/>Te llamaremos pronto.
                  </p>
                  <button onClick={() => setFormSubmitted(false)} className="text-[#e50695] hover:text-[#c40580] font-bold text-sm uppercase tracking-wide border-b-2 border-[#e50695] pb-1">
                    Volver al inicio
                  </button>
                </div>
                )}
            </div>
          </div>}
      </div>
    </div>
  );
}